import { Fluke } from './fluke'
import { FlukePool } from './flukePool'
import { data } from './data'

const MersenneTwister = require('mersenne-twister')
const RandomWeightedChoice = require('random-weighted-choice')

const _ = new WeakMap()
export class Fluker {
  constructor (seed) {
    const __ = {}
    _.set(this, __)

    __.mt = seed ? new MersenneTwister(seed) : new MersenneTwister()
    __.rwc = RandomWeightedChoice

    __.core = {
      integer: function (opts) {
        let r = __.mt.random_int()
        if (opts.delta) r = r % opts.delta
        if (opts.offset) r = opts.offset + r
        return r
      },
      pick: function (opts) {
        if (opts.pool instanceof FlukePool) { return __.core.opick(opts) } else { return opts.pool[__.core.integer({ delta: opts.pool.length })] }
      },
      wpick: function (opts) {
        let r = Number(__.rwc(opts.weights))
        return opts.values[r]
      },
      opick: function (opts) {
        let r = __.core.integer({ delta: opts.pointers.length })
        const newopts = { pool: opts.pointers[r].pointer }
        return __.core.pick(newopts)
      }
    }

    __.flukers = {}
    __.flukers['bool'] = new Fluke({ handler: __.core.pick, options: { pool: [true, false] } })
    __.flukers['pick'] = new Fluke({ handler: __.core.pick })

    __.flukers['integer'] = new Fluke({ handler: __.core.integer, scanner: require('./private/scanners/integer'), predefined: true })
    __.flukers['character'] = new Fluke({ handler: __.core.pick, scanner: require('./private/scanners/character'), predefined: true })
    __.flukers['date'] = new Fluke({ handler: require('./private/handlers/date')(__.core), scanner: require('./private/scanners/date'), predefined: true })
    __.flukers['float'] = new Fluke({ handler: require('./private/handlers/float')(__.core), scanner: require('./private/scanners/float'), predefined: true })

    this.createFromArray('country', data.countries)
    this.createFromArray('firstname', data.firstnames)
    this.createFromArray('lastname', data.lastnames)
    this.createFromArray('title', data.titles)
  }

  fluker (name, specification) {
    const isSetter = !!specification
    const __ = _.get(this)
    if (isSetter) __.flukers[name] = specification
    return __.flukers[name]
  }

  delete (name) {
    const __ = _.get(this)
    delete __.flukers[name]
  }

  create (name, fn) {
    fn = fn.bind(this)
    this.fluker(name, new Fluke({ handler: fn }))
  }

  createFromArray (name, source) {
    this.fluker(name, new Fluke({ handler: this.fluker('pick').handler, options: { pool: source } }))
  }

  createOptimized (name, from, reducedOpts) {
    const flukerSpec = this.fluker(name)
    if (flukerSpec) throw new Error('Fluker already exists')

    const baseFluker = this.fluker(from)
    if (!baseFluker) throw new Error("From fluker doesn't exists")

    const options = baseFluker.scanner ? baseFluker.scanner(reducedOpts) : reducedOpts

    this.fluker(name, new Fluke({ handler: baseFluker.handler, options: options }))
  }

  createNatureBiased (name, source) {
    const pool = new FlukePool(source)
    const scanner = function (opts) {
      let pointers = pool.getDataPointersByNature()
      if (opts && opts.natures) pointers = pool.getDataPointersByNature(opts.natures)
      return {
        pool: pool,
        pointers: pointers
      }
    }

    this.fluker(name, new Fluke({
      handler: this.fluker('pick').handler,
      scanner: scanner,
      branchable: true
    }))
  }

  createWeightBiased (name, source) {
    const __ = _.get(this)
    this.fluker(name, new Fluke({
      handler: __.core.wpick,
      options: require('./private/scanners/wpick')(source)
    }))
  }

  ask (type, opts) {
    const spec = this.fluker(type)
    if (spec) {
      const handler = spec.handler
      const options = spec.options ? spec.options : (spec.scanner ? spec.scanner(opts) : opts)
      return handler(options)
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/fluker.js